import { createContext, useContext, useState } from 'react'

// A field holds the submit of its enclosing Modal/PopUp while it is still preparing its value (e.g. a HEIC photo
// being converted): submitting before it settles would send the form without that value.
type HoldSubmit = (held: boolean) => void

const SubmitHoldContext = createContext<HoldSubmit>(() => {})

export const SubmitHoldProvider = SubmitHoldContext.Provider

export const useHoldSubmit = (): HoldSubmit => useContext(SubmitHoldContext)

// Counts holds so several fields can prepare their value at the same time.
export const useSubmitHolds = (): { isHeld: boolean; holdSubmit: HoldSubmit } => {
  const [holds, setHolds] = useState(0)

  return {
    isHeld: holds > 0,
    holdSubmit: (held) => setHolds((count) => Math.max(0, count + (held ? 1 : -1))),
  }
}
